import React from 'react';
import {
    required,
    TextInput,
    DateInput,
    SimpleForm,
    Create,
    SelectInput,
    ArrayInput,
    SimpleFormIterator,
    CardActions,
    ListButton, 
    Toolbar, 
    ShowButton,
    SaveButton, 
    BooleanInput,
    FormDataConsumer ,
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
import jwt_decode from 'jwt-decode'
import GetInstrumentList from '../../controls/GetInstrumentList';
import ErrorBoundary from '../../ErrorBoundary';

var role = (localStorage && localStorage.token)? (jwt_decode(localStorage.token)? jwt_decode(localStorage.token).role : ''): '';
var level =  (localStorage && localStorage.token)? (jwt_decode(localStorage.token)? jwt_decode(localStorage.token).level : ''): '';
var loc= (localStorage && localStorage.token)? (jwt_decode(localStorage.token)? jwt_decode(localStorage.token).location : ''): '';
var ins_id= null;


export const styles = {

     inlineBlock: {
         display: 'inline-flex', 
         marginRight: '1rem' 
     },
     inlineBlockLeft: {
         display: 'inline-flex',
         float:    'left', 
         marginRight: '1rem' 
     },
     hidden : {
         display: 'none'
     },
     inputStyle : {
         width :'20px',
     },
     controlInputStyle : {
        width :'70px',
        fontSize: '8'
    },
     labelStyle : {
        width :'40px',
        backgroundColor: 'silver'
    },
    iniLabelStyle : {
        width :'20px',
        backgroundColor: 'silver'
    },
    dateStyle : {
        width: '120px',
        
    },
    tableStyle :{ 
        margin: 'auto',  
        fontSize:'12px', 
        fontWeight:'bold', 
        cellspacing:"3", 
        border:'1px solid  black', 
        width: "100%"
    },
    h3: {
        textAlign: 'center',
        width: '100%'
    },
    clearTableStyle :{ 
        margin: 'auto',  
        fontSize:'12px', 
        cellspacing:"3", 
        border:'0px solid  black', 
        width: "100%"
    },
    inlineBlock: {
        display: 'inline-flex',
        margin: '5px',
        padding: '5px',
    },

 };
 
const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const UserCreateActions = ({ basePath, data, resource }) => (
    <CardActions style={cardActionStyle}>
        <ListButton basePath={basePath} />
    </CardActions>
);


const UserCreateToolbar = props => (
    <Toolbar {...props} >
        <SaveButton
            label="save"
            redirect="list"
            submitOnEnter={true}
        />
    </Toolbar>
);

const IsPass = [
    {
        id: 'P',
        name: 'Pass'
    },
    {
        id: 'F',
        name: 'Fail'
    }
]

const InstCreate = ({classes, ...props }) => (
<ErrorBoundary>  
    <Create actions={<UserCreateActions />}   {...props}>
        <SimpleForm toolbar={<UserCreateToolbar />} >
            <table className={classes.clearTableStyle}>
                <tbody>
                    <tr>
                        <td colSpan={4} ><center><h3>EQUIPMENT INCIDENT REPORT</h3></center></td>
                    </tr>
                    <tr>
                        <td>Center Name:</td><td><TextInput source='center' disabled label='' defaultValue={loc} /></td>
                        <td>Equipment item MFR/Name:</td>
                        <td><GetInstrumentList  lable='' /></td>
                    </tr>
                    <tr>
                        <td>Date:</td><td><DateInput source="eq_dt" label=""   locales='en-us' /></td>
                        <td>Type of problem/ Description of defect:</td><td><TextInput source="defect" label=""   /></td>
                    </tr>
                    <tr>
                        <td>Reported To:</td><td><TextInput source="rpt_to" label=""   /></td>
                        <td>Reported By:</td><td><TextInput source="rpt_by" label=""   /></td>
                    </tr>
                    <tr>
                        <td>Resolution:</td><td><TextInput source="resolution" label=""   /></td>
                        <td>Date removed from service:</td><td><DateInput source="rm_dt" label=""   locales='en-us' /></td>
                    </tr>
                    <tr>
                        <td>Tech Inital</td><td><TextInput source='r_tech_init'  label=''/></td>
                        <td>Date</td><td><DateInput source='r_tech_dt'  locales='en-us'  label=''/></td>
                    </tr>
                    <tr>
                        <td>Date returned to service:</td><td><DateInput source='ret_dt'  locales='en-us'  label=''/></td>
                    </tr>
                    <tr>
                        <td>Tech Initial:</td><td><TextInput source="tech_init" label=""   /></td>
                        <td>QA Initial:</td><td><TextInput source="qa_init" label=""   /></td>
                    </tr>
                </tbody>
            </table>
        </SimpleForm>
        
    </Create> 
    </ErrorBoundary>  
);

export default  withStyles(styles) (InstCreate);
